<template>
  <div>
    <enterprise-table v-show="activeKey===1" ref="list" @add="add" @edit="edit"/>
    <enterprise-detail v-show="activeKey===2" ref="detail" @back="back"/>
  </div>
</template>
<script>
import EnterpriseTable from '@/views/basedata/enterprise/EnterpriseTable.vue'
import EnterpriseDetail from '@/views/basedata/enterprise/EnterpriseDetail.vue'

export default {
  name: 'EnterpriseBaseData',
  components: { EnterpriseTable, EnterpriseDetail },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    }
  }
}
</script>